import '../styles.scss'
import React from 'react'

import { Selector, Assignment, Toggle } from 'components/SmartChatView/Fields'

const AssignmentViewUI = ({
  renderType,
  label,
  placeholder,
  assignationTypeOptions,
  operatorsOptions,
  value,
  resetAssignmentInnerValue,
  onChangeInner,
  getOperatorsOptions,
  loadingOperatorsOptions,
  error,
  previewIntegrity
}) => {
  return (
    <div className='action-view'>
      {renderType === 'action' ? (
        <>
          <Selector
            isRequired
            label={label.assignationType}
            placeholder={placeholder.assignationType}
            options={assignationTypeOptions}
            value={value.assignationType}
            onChange={value => {
              onChangeInner({ fieldType: 'assignationType', fieldData: value })
            }}
            error={error?.assignationType}
          />
          {value.assignationType?.value === 'removeOperator' ? (
            <Toggle
              label={label.removeAllOperators}
              value={!!value.removeAll}
              onChange={value => onChangeInner({ fieldType: 'removeAll', fieldData: value })}
              error={error?.removeAll}
            />
          ) : null}
          {(value.assignationType && !value.removeAll) ? (
            <Assignment
              isRequired
              label={value.assignationType?.value === 'delegation'
                ? label.delegation
                : value.assignationType?.value === 'operator'
                  ? label.operator
                  : label.removeOperator
              }
              placeholder={{
                brand: placeholder.brand,
                delegation: placeholder.delegation,
                operator: placeholder.operator
              }}
              options={operatorsOptions || []}
              value={{
                brand: value.brand,
                delegation: value.delegation,
                operator: value.operator
              }}
              resetAssignmentInnerValue={resetAssignmentInnerValue}
              onChange={(value) => {
                onChangeInner({ fieldType: 'assignment', fieldData: value })
              }}
              isOperatorField={['operator', 'removeOperator'].includes(value.assignationType?.value) ? true : false}
              loading={loadingOperatorsOptions}
              getOperatorsOptions={getOperatorsOptions}
              error={{
                brand: error?.brand,
                delegation: error?.delegation,
                operator: error?.operator
              }}
            />
          ) : null}
        </>
      ) : null}
      {renderType === 'preview' ? (
        <div className='action-view__assignment-preview'>
          <Selector
            placeholder={placeholder.assignationType}
            options={assignationTypeOptions}
            value={value.assignationType}
            onChange={(value) => {
              onChangeInner({ fieldType: 'assignationType', fieldData: value })
            }}
            error={previewIntegrity.assignationType}
          />
          {!value.removeAll ? (
            <Assignment
              placeholder={{
                brand: placeholder.brand,
                delegation: placeholder.delegation,
                operator: placeholder.operator
              }}
              options={operatorsOptions || []}
              value={{
                brand: value.brand,
                delegation: value.delegation,
                operator: value.operator
              }}
              resetAssignmentInnerValue={resetAssignmentInnerValue}
              onChange={(value) => {
                onChangeInner({ fieldType: 'assignment', fieldData: value })
              }}
              isOperatorField={['operator', 'removeOperator'].includes(value.assignationType?.value) ? true : false}
              loading={loadingOperatorsOptions}
              getOperatorsOptions={getOperatorsOptions}
              error={{
                brand: previewIntegrity.brand,
                delegation: previewIntegrity.delegation,
                operator: previewIntegrity.operator
              }}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default AssignmentViewUI
